module.exports = __webpack_public_path__ + "img/logo-inverted.e1a7625d.svg";